import EventPhaseEventTime from "app/components/EventPhaseEventTime/EventPhaseEventTime";
import { IconCorner } from "app/components/Icon/Icon";
import MomentTime from "app/components/Moment/components/MomentTime/MomentTime";
import TimeSectionTimePhase from "app/components/TimeSectionLivePhase/TimeSectionTimePhase";
import { EventHelper } from "app/helpers/eventHelper";
import type { EventIncidentType, EventType } from "app/types/eventType";
import { ScreenType, SportsNameType } from "app/utils/const";
import React from "react";
import "./EventStats.scss";

type Props = {
  eventIncidents: EventIncidentType[];
  eventStartTime: string;
  event: EventType;
};

const EventStats: React.FC<Props> = ({ eventIncidents, event }) => {
  const renderEventPhaseAndTime = () => {
    const isBeforeExtra = EventHelper.isBeforeExtraTime(event);
    const isEventInExtraTime = EventHelper.isEventInExtraTime(event);
    const isGolfEvent = event.sportType === SportsNameType.GOLF;
    const isEventLive = EventHelper.isEventLive(event);

    const eventTime = eventIncidents ? (
      <div className="popular-event-cell__event-time">
        {isGolfEvent && isEventLive ? (
          <div className="time">
            <TimeSectionTimePhase />
          </div>
        ) : (
          <EventPhaseEventTime
            eventData={event}
            eventIncidents={eventIncidents}
            isBeforeExtra={isBeforeExtra}
            isEventInExtraTime={isEventInExtraTime}
            screenType={ScreenType.EUROPEAN}
          />
        )}
      </div>
    ) : (
      <MomentTime value={event["startTime"]} countDown />
    );
    return eventTime;
  };

  const renderSoccerStats = () => {
    const yellowCards = {
      home: 0,
      away: 0,
    };
    const redCards = {
      home: 0,
      away: 0,
    };
    const corners = {
      home: 0,
      away: 0,
    };
    let eventStat: EventIncidentType | null = null;

    if (eventIncidents != null) {
      eventStat = eventIncidents[0];

      if (eventStat["eventPhase"].includes("EXTRA_TIME")) {
        eventStat["currentPeriodScoreDetails"].forEach(currentScore => {
          switch (currentScore.type) {
            case "HOME_YELLOW_CARD":
              yellowCards.home += currentScore.score;
              break;

            case "AWAY_YELLOW_CARD":
              yellowCards.away += currentScore.score;
              break;

            case "HOME_RED_CARD":
              redCards.home += currentScore.score;
              break;

            case "AWAY_RED_CARD":
              redCards.away += currentScore.score;
              break;

            case "HOME_CORNER":
              corners.home += currentScore.score;
              break;

            case "AWAY_CORNER":
              corners.away += currentScore.score;
              break;

            default:
              return null;
          }
        });
      } else {
        eventStat["scoreDetails"].forEach(currentScore => {
          switch (currentScore.type) {
            case "HOME_YELLOW_CARD":
              yellowCards.home += currentScore.score;
              break;

            case "AWAY_YELLOW_CARD":
              yellowCards.away += currentScore.score;
              break;

            case "HOME_RED_CARD":
              redCards.home += currentScore.score;
              break;

            case "AWAY_RED_CARD":
              redCards.away += currentScore.score;
              break;

            case "HOME_CORNER":
              corners.home += currentScore.score;
              break;

            case "AWAY_CORNER":
              corners.away += currentScore.score;
              break;

            default:
              return null;
          }
        });
      }
    }

    return (
      <div className="event-incident__incident">
        <div className="event-incident__incident__row">
          <div className="event-incident__incident__column">
            {yellowCards.home}
          </div>
          <div className="event-incident__scores event-incident__scores--yellow-cards" />
          <div className="event-incident__incident__column">
            {yellowCards.away}
          </div>
        </div>
        <div className="event-incident__incident__row">
          <div className="event-incident__incident__column">
            {redCards.home}
          </div>
          <div className="event-incident__scores event-incident__scores--red-cards" />
          <div className="event-incident__incident__column">
            {redCards.away}
          </div>
        </div>
        <div className="event-incident__incident__row">
          <div className="event-incident__incident__column">{corners.home}</div>
          <div className="event-incident__scores event-incident__scores--corners-icon">
            <IconCorner />
          </div>
          <div className="event-incident__incident__column">{corners.away}</div>
        </div>
      </div>
    );
  };

  if (eventIncidents == null) {
    return null;
  }

  return (
    <div className="event-incident">
      <div className="event-incident__time">{renderEventPhaseAndTime()}</div>
      {event.sportType === SportsNameType.SOCCER && renderSoccerStats()}
    </div>
  );
};

export default EventStats;
